import React from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { redirectToSignIn } from 'utils/helpers/urlHelpers';

import { BuilderAuthMessage } from '../BuilderAuthMessage/BuilderAuthMessage';

export const BuilderLinkExpired = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <BuilderAuthMessage
      tabTitle={t('pages.auth.linkExpired.tabTitle')}
      title={t('pages.auth.linkExpired.linkExpiredTitle')}
      text={t('pages.auth.linkExpired.linkExpiredText')}
      buttonText={t('pages.auth.linkExpired.linkExpiredBtn')}
      onBack={redirectToSignIn}
      onButtonClick={redirectToSignIn}
    />
  );
};
